module.exports = __webpack_public_path__ + "img/loading.edf4241f.gif";